import { BaseApi } from '@/api/BaseApi'
import Config from '@/const/Config'
import { AuthInfo, PasswordForgotReq, PasswordForgotRes, PasswordResetFromAdminReq, PasswordResetReq, PasswordResetRes, UserRegistReq } from '@/types/User'

export class UserApi extends BaseApi {

  /**
   * 自分のユーザー情報を取得します
   * @returns 
   */
  public async getMe(): Promise<AuthInfo> {
    try {
      const res = await this.get<AuthInfo>(Config.API_URL + '/user/me')
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }

  public async regist(req: UserRegistReq) {
    try {
      const res = await this.post('/register', req)
      return res.data
    } catch (e: any) {
      console.error('e', e)
      throw e
    }
  }

  public async forgotPassword(req: PasswordForgotReq) {
    try {
      const res = await this.post<PasswordForgotRes>('/forgot_password', req)
      return res.data
    } catch (e: any) {
      console.error('e', e)
      throw e
    }
  }

  /**
   * ゲストによるパスワードリセット
   * @param req 
   * @returns 
   */
  public async resetPassword(req: PasswordResetReq) {
    try {
      const res = await this.post<PasswordResetRes>('/reset_password', req)
      return res.data
    } catch (e: any) {
      console.error('e', e)
      throw e
    }
  }

  /**
   * 管理者によるパスワードリセット
   * @param req 
   * @returns 
   */
  public async resetPasswordFromAdminn(req: PasswordResetFromAdminReq) {
    try {
      const res = await this.post<PasswordResetRes>('/api/reset_password_from_admin', req)
      return res.data
    } catch (e: any) {
      console.error('e', e)
      throw e
    }
  }

  /**
   * ログイン中のユーザーのパスワードを確認します
   * @param password
   * @returns 
   */
  public async verifyPassword(password: string) {
    try {
      const res = await this.post<boolean>('/api/verify_password', { password })
      return res.data
    } catch (e: any) {
      console.error('e', e)
      throw e
    }
  }
}